<template>
  <b-container class="py-4">
    <div class="d-flex justify-content-between align-items-center mb-3 flex-wrap">
      <h2 class="mb-2">Cajas de regalo</h2>
      <b-button :to="{ name: 'NuevaCajaRegalo' }" variant="primary">+ Nueva caja</b-button>
    </div>

    <p class="text-muted">
      Cada caja tiene su propia página en el sitio y lista sus <strong>alternativas</strong> (versiones de escapada).
      Se recomienda publicar una caja solo con <strong>8 o más</strong> alternativas.
    </p>

    <b-alert v-if="cajas.length === 0 && !loading" show variant="info">
      Aún no hay cajas. Crea la primera con “Nueva caja”.
    </b-alert>

    <b-table
      v-if="cajas.length"
      :items="items"
      :fields="fields"
      responsive
      striped
      hover
      class="align-middle"
    >
      <template #cell(publicada)="row">
        <b-badge :variant="row.item.publicada ? 'success' : 'secondary'">
          {{ row.item.publicada ? 'Publicada' : 'Borrador' }}
        </b-badge>
      </template>
      <template #cell(alternativas)="row">
        <b-badge :variant="alertLow(row.item) ? 'danger' : 'light'">
          {{ row.item.nAlt }}
        </b-badge>
        <b-icon
          v-if="alertLow(row.item)"
          icon="exclamation-triangle-fill"
          variant="danger"
          title="Publicada con menos de 8 alternativas"
        />
      </template>
      <template #cell(precio)="row">$ {{ formatPrecio(row.item.precio) }}</template>
      <template #cell(acciones)="row">
        <b-button size="sm" variant="outline-primary" :to="{ name: 'EditCajaRegalo', params: { slug: row.item.slug } }">
          Editar
        </b-button>
        <b-button
          size="sm"
          :variant="row.item.publicada ? 'outline-secondary' : 'outline-success'"
          class="ml-1"
          @click="togglePublicada(row.item)"
        >
          {{ row.item.publicada ? 'Despublicar' : 'Publicar' }}
        </b-button>
        <b-button size="sm" variant="outline-danger" class="ml-1" @click="eliminar(row.item)">
          Eliminar
        </b-button>
      </template>
    </b-table>
  </b-container>
</template>

<script>
import { db } from "../../firebase.service";

export default {
  name: "CajasRegalo",
  data() {
    return {
      cajas: [],
      conteo: {}, // slug -> nº versiones publicadas
      loading: true,
      unsub: null,
      fields: [
        { key: "nombre", label: "Nombre", sortable: true },
        { key: "precio", label: "Precio", sortable: true },
        { key: "noches", label: "Noches" },
        { key: "alternativas", label: "Alternativas" },
        { key: "orden", label: "Orden", sortable: true },
        { key: "publicada", label: "Estado" },
        { key: "acciones", label: "Acciones" },
      ],
    };
  },
  computed: {
    items() {
      return [...this.cajas]
        .sort((a, b) => (Number(a.orden) || 0) - (Number(b.orden) || 0))
        .map((c) => ({ ...c, nAlt: this.conteo[c.slug || c.id] || 0 }));
    },
  },
  created() {
    this.unsub = db.collection("cajas").onSnapshot((snap) => {
      this.cajas = snap.docs.map((d) => ({ id: d.id, slug: d.id, ...d.data() }));
      this.loading = false;
    });
    this.cargarConteos();
  },
  beforeDestroy() {
    if (this.unsub) this.unsub();
  },
  methods: {
    formatPrecio(n) {
      return (Number(n) || 0).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
    },
    alertLow(item) {
      return item.publicada && (item.nAlt || 0) < 8;
    },
    async cargarConteos() {
      try {
        const snap = await db.collectionGroup("versiones").get();
        const conteo = {};
        snap.forEach((d) => {
          const v = d.data();
          if (v.publicada !== true || !Array.isArray(v.cajaSlugs)) return;
          v.cajaSlugs.forEach((s) => { conteo[s] = (conteo[s] || 0) + 1; });
        });
        this.conteo = conteo;
      } catch (e) {
        // collectionGroup puede requerir índice; si falla, mostramos 0.
        console.warn("[CajasRegalo] conteo versiones fallido:", e && e.message);
      }
    },
    async togglePublicada(item) {
      const next = !item.publicada;
      if (next && (this.conteo[item.slug] || 0) < 8) {
        if (!confirm("Esta caja tiene menos de 8 alternativas. ¿Publicar igual?")) return;
      }
      try {
        await db.collection("cajas").doc(item.slug || item.id).update({ publicada: next });
      } catch (e) {
        alert("No se pudo actualizar: " + (e && e.message));
      }
    },
    async eliminar(item) {
      if (!confirm(`¿Eliminar la caja "${item.nombre}"? Las versiones NO se borran (siguen bajo sus escapadas).`)) return;
      try {
        await db.collection("cajas").doc(item.slug || item.id).delete();
      } catch (e) {
        alert("No se pudo eliminar: " + (e && e.message));
      }
    },
  },
};
</script>
